import * as actionTypes from './actionTypes';

export const setAdult = (value) => {
    return {
        type: actionTypes.SET_ADULT,
        val: value
    }
}

export const setChild = (value) => {
    return {
        type: actionTypes.SET_CHILD,
        val: value
    }
}

export const setInfant = (value) => {
    return {
        type: actionTypes.SET_INFANT,
        val: value
    }
}

export const clickFlightAdult = () => {
    return {
        type: actionTypes.CLICK_FLIGHT_ADULT
    }
}

export const clickFlightChild = () => {
    return {
        type: actionTypes.CLICK_FLIGHT_CHILD
    }
}

export const clickFlightInfant = () => {
    return {
        type: actionTypes.CLICK_FLIGHT_INFANT
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/travellers.js